import React from 'react';
import { ButtonBase, Grid, Typography, Box } from '@material-ui/core';
import { ChevronLeft } from '@material-ui/icons';
import { TabletButton } from '@campfire/tablet-button/lib';
import { useFormikContext } from 'formik';
import { useHistory } from 'react-router';
import { useCampfireTheme } from '../../../../../../theme/useCampfireTheme';

interface Props {
  taskName: string;
  taskId?: string;
  isTaskZero: boolean;
  isManagerTask?: boolean;
  disabled?: boolean;
  isRefereeCheckTask?: boolean;
  isEventTask?: boolean;
  isPaymentTask?: boolean;
}

export const FormBuilderHeader = (props: Props) => {
  const {
    taskName,
    isManagerTask,
    disabled = false,
    isRefereeCheckTask = false,
    isEventTask = false,
    isPaymentTask = false,
    // taskId,
    // isTaskZero
  } = props;
  const { submitForm, resetForm, initialValues, values } = useFormikContext();
  const history = useHistory();

  const { theme, isMobile } = useCampfireTheme();

  // const handleDuplicate = () => {
  //   // Get the current cid from URL if it exists
  //   const urlParams = new URLSearchParams(window.location.search);
  //   const cid = urlParams.get('cid');
  //   const searchParams = cid ? `?cid=${cid}&tid=${taskId}&duplicate=1` : `?tid=${taskId}&duplicate=1`;

  //   history.push({
  //     pathname: '/admin/tasks/task-builder',
  //     search: searchParams,
  //   });
  // };

  return (
    <Box>
      <Grid container alignItems='center' spacing={isMobile ? 1 : 2} style={{ padding: 8 }}>
        <Grid item xs>
          <ButtonBase disableRipple onClick={() => history.goBack()}>
            <Grid container style={{ paddingLeft: isMobile ? 0 : 16 }}>
              <ChevronLeft style={{ color: theme.palette.text.secondary }} />
              <Typography color='textSecondary' noWrap style={{ maxWidth: isMobile ? '160px' : 'auto' }}>
                {taskName}
              </Typography>
            </Grid>
          </ButtonBase>
        </Grid>
        <Grid item>
          {isRefereeCheckTask ? (
            <Box
              style={{
                fontSize: '0.75rem',
                fontWeight: 600,
                padding: 8,
                paddingLeft: 12,
                paddingRight: 12,
                borderRadius: 4,
                backgroundColor: '#f3e5f5',
                color: '#7b1fa2',
                marginRight: 8,
              }}
            >
              Referee Check
            </Box>
          ) : isEventTask ? (
            <Box
              style={{
                fontSize: '0.75rem',
                fontWeight: 600,
                padding: 8,
                paddingLeft: 12,
                paddingRight: 12,
                borderRadius: 4,
                backgroundColor: '#e0f2f1',
                color: '#00695c',
                marginRight: 8,
              }}
            >
              Event Task
            </Box>
          ) : isPaymentTask ? (
            <Box
              style={{
                fontSize: '0.75rem',
                fontWeight: 600,
                padding: 8,
                paddingLeft: 12,
                paddingRight: 12,
                borderRadius: 4,
                backgroundColor: '#fff3e0',
                color: '#ef6c00',
                marginRight: 8,
              }}
            >
              Payment Task
            </Box>
          ) : (
            <Box
              style={{
                fontSize: '0.75rem',
                fontWeight: 600,
                padding: 8,
                paddingLeft: 12,
                paddingRight: 12,
                borderRadius: 4,
                backgroundColor: isManagerTask ? '#FFF4E6' : '#E3F2FD',
                color: isManagerTask ? '#E65100' : '#1565C0',
                marginRight: 8,
              }}
            >
              {isManagerTask ? 'Manager Completes' : 'User Completes'}
            </Box>
          )}
        </Grid>
        <Grid item>
          <TabletButton onClick={() => resetForm()} disabled={disabled || initialValues === values}>
            {isMobile ? 'Discard' : 'Discard changes'}
          </TabletButton>
        </Grid>
        <Grid item>
          <TabletButton color='primary' variant='contained' onClick={() => submitForm()} disabled={disabled}>
            {isMobile ? 'Save' : 'Save changes'}
          </TabletButton>
        </Grid>
        {/* {!isTaskZero ? (
          <Grid item>
            <TabletButton variant='outlined' onClick={handleDuplicate} disabled={!taskId}>
              {'Duplicate'}
            </TabletButton>
          </Grid>
        ) : null} */}
      </Grid>
    </Box>
  );
};
